export class ListBackupPoliciesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupPolicies",
            "baseName": "backupPolicies",
            "type": "Array<BackupPolicy>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListBackupPoliciesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
